import React from "react";
import Moment from "react-moment";
import { Modal } from "react-bootstrap";
import { getWfPhasesColor } from "../services/appService";

const getPhaseIcon = (phase) => {
  switch (phase) {
    case "Approved": return "fa-check-circle";
    case "Denied": case "Rejected": return "fa-times-circle";
    case "Application": return "fa-file-text-o";
    case "Onboarding": return "fa-user-plus";
    case "Review": return "fa-check-square-o";
    case "Compliance": return "fa-shield";
    case "Time Log": return "fa-clock-o";
    case "Invoice": return "fa-file-text";
    case "Pending": return "fa-hourglass-half";
    default: return "fa-tag";
  }
};

const TaskHistory = (props) => {
  const {
    historyAppShowHide,
    handlehistoryAppModalShowHide,
    selectedObj: task,
    doneTasks,
    taskPhases = [],
  } = props;

  const themeClass = task
    ? (getWfPhasesColor(task.wfPhase) || "btn-default").replace("btn-", "theme-")
    : "theme-default";

  const getPhaseBadgeColorClass = (phase) => getWfPhasesColor(phase) || "btn-default";

  const getSortValue = (value) => {
    const numberValue = Number(value);
    return Number.isFinite(numberValue) ? numberValue : Number.MAX_SAFE_INTEGER;
  };

  const getDisplayValue = (value) => {
    if (value === 0) return 0;
    return value || "-";
  };

  const getTaskStateLabel = (value) => {
    switch (Number(value)) {
      case 0:
      case 1:
        return "Not Started";
      case 2:
        return "In Process";
      case 3:
        return "Suspended";
      case 4:
        return "Completed";
      default:
        return getDisplayValue(value);
    }
  };

  const getItemTypeLabel = (value) => {
    switch (Number(value)) {
      case 1:
        return "Person Based Task";
      case 3:
        return "Conditional Task";
      case 4:
        return "Automated Task";
      default:
        return getDisplayValue(value);
    }
  };

  const shouldShowPerformer = (item) => Number(item?.itemType) === 1;

  const phaseOrder = (taskPhases || [])
    .map((phase, index) => ({
      name: phase?.wfPhase || phase?.phase || phase,
      order: getSortValue(phase?.orderNumber),
      index,
    }))
    .filter((phase) => phase.name)
    .sort((a, b) => a.order - b.order || a.index - b.index)
    .reduce((orderMap, phase, index) => {
      if (!orderMap.has(phase.name)) orderMap.set(phase.name, index);
      return orderMap;
    }, new Map());

  const sortedDoneTasks = [...(doneTasks || [])].sort((a, b) => {
    const phaseA = phaseOrder.has(a.wfPhase) ? phaseOrder.get(a.wfPhase) : getSortValue(a.orderNumber);
    const phaseB = phaseOrder.has(b.wfPhase) ? phaseOrder.get(b.wfPhase) : getSortValue(b.orderNumber);

    return (
      phaseA - phaseB ||
      getSortValue(a.orderNumber) - getSortValue(b.orderNumber) ||
      getSortValue(a.wiid) - getSortValue(b.wiid)
    );
  });

  const candidateName = task?.performerName || task?.applicantName || task?.name || "";
  const email = task?.performerEmail || task?.applicantEmail || task?.email || "";
  const phone = task?.performerPhone || task?.phone || task?.cellPhone || "";
  if (!historyAppShowHide) return null;

  return (
    <Modal
      show={Boolean(historyAppShowHide)}
      onHide={handlehistoryAppModalShowHide}
      size="xl"
      dialogClassName={`rt-history-modal ${themeClass}`}
      centered
    >
      <style>{`
        /* Ensure the modal and backdrop are on top of sidebars/headers */
        .modal-backdrop {
          z-index: 1080 !important;
        }
        .modal {
          z-index: 1090 !important;
        }

        .rt-history-modal {
          max-width: 90% !important;
          width: 1200px !important;
        }

        .rt-history-modal .modal-content {
          border-radius: 0 !important;
          box-shadow: 0 20px 25px -5px rgba(0,0,0,0.1), 0 8px 10px -6px rgba(0,0,0,0.1) !important;
          border: 1px solid #cbd5e1 !important;
          overflow: hidden !important;
          background: #ffffff !important;
          font-family: inherit !important;
        }

        .rt-history-modal .modal-header {
          position: relative !important;
          padding: 16px 20px !important;
          background: #ffffff !important;
          border-bottom: 1px solid #e2e8f0 !important;
          border-radius: 0 !important;
        }

        .rt-history-modal .rt-header-shell {
          width: 100% !important;
        }

        .rt-history-modal .rt-header-top {
          display: flex !important;
          justify-content: space-between !important;
          align-items: center !important;
          gap: 12px !important;
        }

        .rt-history-modal .rt-header-main {
          display: flex !important;
          align-items: center !important;
          gap: 12px !important;
          min-width: 0 !important;
          flex: 1 !important;
        }

        .rt-history-modal .rt-header-copy {
          display: flex !important;
          flex-direction: column !important;
          gap: 4px !important;
          min-width: 0 !important;
        }

        .rt-history-modal .rt-modal-title {
          display: inline-flex !important;
          align-items: center !important;
          margin: 0 !important;
          color: #1e293b !important;
          font-size: 18px !important;
          font-weight: 500 !important;
          line-height: 1.2 !important;
          min-width: 0 !important;
        }

        .rt-history-modal .rt-header-icon {
          width: 52px !important;
          height: 52px !important;
          min-height: 52px !important;
          border-radius: 0 !important;
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          color: #171717 !important;
          background: #f5f5f5 !important;
          border: 1px solid #d4d4d4 !important;
          box-shadow: 0 2px 6px -2px rgba(15,23,42,0.08) !important;
          font-size: 18px !important;
          flex-shrink: 0 !important;
        }

        .rt-history-modal .rt-modal-title-text {
          display: inline-flex !important;
          align-items: center !important;
          gap: 12px !important;
          min-width: 0 !important;
          flex-wrap: wrap !important;
        }

        .rt-history-modal .rt-modal-title-badge {
          display: inline-flex !important;
          align-items: center !important;
          gap: 5px !important;
          padding: 3px 8px !important;
          height: 22px !important;
          box-sizing: border-box !important;
          border-radius: 0 !important;
          font-size: 11px !important;
          font-weight: 600 !important;
          text-transform: uppercase !important;
          letter-spacing: 0.02em !important;
          background: #171717 !important;
          color: #ffffff !important;
          border: 1px solid #171717 !important;
          line-height: 1 !important;
        }
        .rt-history-modal .rt-modal-title-badge i {
          font-size: 10.5px !important;
        }
        .rt-history-modal .rt-modal-title-badge.btn-primary { background: #eff6ff !important; color: #2563eb !important; border-color: #bfdbfe !important; }
        .rt-history-modal .rt-modal-title-badge.btn-info { background: #ecfeff !important; color: #0891b2 !important; border-color: #a5f3fc !important; }
        .rt-history-modal .rt-modal-title-badge.btn-warning { background: #fffbeb !important; color: #d97706 !important; border-color: #fde68a !important; }
        .rt-history-modal .rt-modal-title-badge.btn-success { background: #f0fdf4 !important; color: #16a34a !important; border-color: #bbf7d0 !important; }
        .rt-history-modal .rt-modal-title-badge.btn-wf2-default { background: #fef9c3 !important; color: #ca8a04 !important; border-color: #fef08a !important; }
        .rt-history-modal .rt-modal-title-badge.btn-wf3-default { background: #ecfdf5 !important; color: #059669 !important; border-color: #a7f3d0 !important; }
        .rt-history-modal .rt-modal-title-badge.btn-wf4-default { background: #fef2f2 !important; color: #dc2626 !important; border-color: #fecaca !important; }
        .rt-history-modal .rt-modal-title-badge.btn-wf5-default { background: #fff7ed !important; color: #ea580c !important; border-color: #fed7aa !important; }
        .rt-history-modal .rt-modal-title-badge.btn-wf6-default { background: #f5f3ff !important; color: #7c3aed !important; border-color: #ddd6fe !important; }
        .rt-history-modal .rt-modal-title-badge.btn-default,
        .rt-history-modal .rt-modal-title-badge.btn-wf-default { background: #f1f5f9 !important; color: #475569 !important; border-color: #cbd5e1 !important; }

        .rt-history-modal .rt-modal-meta-row {
          display: flex !important;
          align-items: center !important;
          flex-wrap: wrap !important;
          gap: 8px !important;
          margin-top: 0 !important;
          padding-left: 0 !important;
          font-size: 12px !important;
          font-weight: 400 !important;
          color: #64748b !important;
        }

        .rt-history-modal .rt-meta-chip {
          display: inline-flex !important;
          align-items: center !important;
          gap: 4px !important;
          background: #ffffff !important;
          padding: 3px 8px !important;
          height: 24px !important;
          min-height: 24px !important;
          box-sizing: border-box !important;
          border-radius: 0 !important;
          font-size: 11.5px !important;
          font-weight: 500 !important;
          color: #0f172a !important;
          border: 1px solid #cbd5e1 !important;
          box-shadow: none !important;
          line-height: 1 !important;
        }

        .rt-history-modal .rt-meta-chip i,
        .rt-history-modal .rt-meta-chip .fa {
          font-size: 11.5px !important;
          margin-right: 4px !important;
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
        }

        .rt-history-modal .rt-meta-chip i.fa-user { color: #9333ea !important; }
        .rt-history-modal .rt-meta-chip i.fa-envelope, .rt-history-modal .rt-meta-chip i.fa-envelope-o { color: #0284c7 !important; }
        .rt-history-modal .rt-meta-chip i.fa-phone { color: #16a34a !important; }
        .rt-history-modal .rt-meta-chip i.fa-tasks, .rt-history-modal .rt-meta-chip i.fa-database { color: #2563eb !important; }
        .rt-history-modal .rt-meta-chip i.fa-info-circle { color: #0891b2 !important; }
        .rt-history-modal .rt-meta-chip i.fa-id-badge { color: #6366f1 !important; }
        .rt-history-modal .rt-meta-chip i.fa-hashtag { color: #d97706 !important; }

        /* Close Button */
        .rt-history-modal .rt-action-btn {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          width: 32px !important;
          height: 32px !important;
          padding: 0 !important;
          font-size: 13.5px !important;
          font-weight: 500 !important;
          color: #64748b !important;
          background: #ffffff !important;
          border: 1px solid #cbd5e1 !important;
          border-radius: 0 !important;
          cursor: pointer !important;
          transition: all 0.15s ease !important;
          box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04) !important;
          outline: none !important;
          font-family: inherit !important;
        }
        .rt-history-modal .rt-action-btn:hover {
          color: #dc2626 !important;
          border-color: #fca5a5 !important;
          background: #fef2f2 !important;
          transform: translateY(-1px) !important;
        }

        /* Modal Footer */
        .rt-history-modal .modal-footer {
          background: #ffffff !important;
          border-top: 1px solid #e2e8f0 !important;
          padding: 14px 20px !important;
          display: flex !important;
          justify-content: flex-end !important;
          gap: 10px !important;
        }
        .rt-history-modal .wf-modal-footer-close-btn {
          display: inline-flex !important;
          align-items: center !important;
          gap: 4px !important;
          padding: 7px 18px !important;
          font-size: 13.5px !important;
          font-weight: 500 !important;
          color: #1e293b !important;
          background: #ffffff !important;
          border: 1px solid #cbd5e1 !important;
          border-radius: 0 !important;
          box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04) !important;
          outline: none !important;
          cursor: pointer !important;
          transition: all 0.15s ease !important;
          font-family: inherit !important;
        }
        .rt-history-modal .wf-modal-footer-close-btn:hover {
          background: #f8fafc !important;
          color: #0f172a !important;
          border-color: #94a3b8 !important;
          transform: translateY(-1px) !important;
          box-shadow: 0 2px 4px rgba(15, 23, 42, 0.08) !important;
        }

        .rt-history-modal .modal-body {
          padding: 20px 24px !important;
          background: #ffffff !important;
          max-height: calc(100vh - 200px) !important;
          overflow-y: auto !important;
        }

        /* Empty State */
        .wf-table-empty {
          position: relative !important;
          display: flex !important;
          flex-direction: column !important;
          align-items: center !important;
          justify-content: center !important;
          padding: 56px 24px 48px !important;
          text-align: center !important;
          overflow: hidden !important;
          background: #ffffff !important;
          border-radius: 16px !important;
          margin: 12px !important;
          border: 1.5px solid rgba(37,99,235,0.08) !important;
        }
        .wf-te-icon-wrap {
          position: relative !important;
          width: 80px !important;
          height: 80px !important;
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          margin-bottom: 24px !important;
          z-index: 1 !important;
        }
        .wf-te-icon {
          width: 72px !important;
          height: 72px !important;
          border-radius: 16px !important;
          background: #f8fafc !important;
          border: 1.5px solid #e2e8f0 !important;
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          font-size: 28px !important;
          color: #94a3b8 !important;
          position: relative !important;
          z-index: 2 !important;
        }
        .wf-te-title {
          font-size: 14px !important;
          font-weight: 500 !important;
          color: #1e293b !important;
          margin: 0 0 10px 0 !important;
          line-height: 1.3 !important;
        }
        .wf-te-desc {
          font-size: 14px !important;
          font-weight: 400 !important;
          color: #64748b !important;
          margin: 0 !important;
          line-height: 1.65 !important;
        }

        /* ---- Timeline UI ---- */
        .rt-history-stats-bar {
          display: flex !important;
          align-items: center !important;
          gap: 24px !important;
          margin-bottom: 16px !important;
          padding: 12px 18px !important;
          background: #f8fafc !important;
          border: 1px solid #e2e8f0 !important;
          border-radius: 0 !important;
        }
        .rt-stat-item {
          display: flex !important;
          flex-direction: column !important;
          gap: 2px !important;
        }
        .rt-stat-label {
          font-size: 10.5px !important;
          font-weight: 600 !important;
          color: #64748b !important;
          text-transform: uppercase !important;
          letter-spacing: 0.04em !important;
        }
        .rt-stat-value {
          font-size: 13.5px !important;
          font-weight: 600 !important;
          color: #0f172a !important;
        }
        .rt-stat-divider {
          width: 1px !important;
          height: 28px !important;
          background: #cbd5e1 !important;
        }

        .rt-history-timeline {
          position: relative !important;
          padding-left: 36px !important;
          margin: 0 !important;
        }
        .rt-history-timeline::before {
          content: '' !important;
          position: absolute !important;
          top: 0 !important;
          bottom: 0 !important;
          left: 15px !important;
          width: 2px !important;
          background: #e2e8f0 !important;
        }

        .rt-history-timeline-item {
          position: relative !important;
          margin-bottom: 14px !important;
        }
        .rt-history-timeline-item:last-child {
          margin-bottom: 0 !important;
        }
        .rt-history-timeline-badge {
          position: absolute !important;
          left: -36px !important;
          top: 14px !important;
          width: 32px !important;
          height: 32px !important;
          border-radius: 0 !important;
          background: #ffffff !important;
          border: 1px solid #cbd5e1 !important;
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          z-index: 1 !important;
          color: #171717 !important;
          font-size: 13px !important;
          font-weight: 600 !important;
        }
        .rt-history-timeline-card {
          position: relative !important;
          background: #ffffff !important;
          border: 1px solid #e2e8f0 !important;
          border-radius: 0 !important;
          padding: 0 !important;
          box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04) !important;
          transition: border-color 0.15s ease !important;
        }
        .rt-history-timeline-card:hover {
          border-color: #cbd5e1 !important;
        }

        .rt-tl-card-header {
          display: flex !important;
          justify-content: space-between !important;
          align-items: center !important;
          padding: 10px 16px !important;
          background: #f8fafc !important;
          border-bottom: 1px solid #e2e8f0 !important;
          flex-wrap: wrap !important;
          gap: 8px !important;
        }
        .rt-tl-card-title-row {
          display: flex !important;
          align-items: center !important;
          gap: 8px !important;
          min-width: 0 !important;
          flex-wrap: wrap !important;
        }
        .rt-tl-card-name {
          font-size: 14px !important;
          font-weight: 600 !important;
          color: #0f172a !important;
          line-height: 1.2 !important;
        }
        .rt-tl-card-id,
        .rt-tl-order-chip {
          font-size: 11px !important;
          font-weight: 500 !important;
          color: #64748b !important;
          background: #ffffff !important;
          padding: 2px 7px !important;
          border-radius: 0 !important;
          border: 1px solid #cbd5e1 !important;
        }
        .rt-history-phase-badge {
          background: #f1f5f9 !important;
          color: #334155 !important;
          border: 1px solid #cbd5e1 !important;
          font-size: 10.5px !important;
          font-weight: 600 !important;
          padding: 2px 8px !important;
          border-radius: 0 !important;
          text-transform: uppercase !important;
          letter-spacing: 0.02em !important;
        }

        .rt-tl-card-duration {
          font-size: 11.5px !important;
          font-weight: 500 !important;
          color: #475569 !important;
          background: #ffffff !important;
          padding: 3px 8px !important;
          border-radius: 0 !important;
          border: 1px solid #cbd5e1 !important;
        }

        .rt-tl-card-body {
          padding: 14px 16px !important;
          display: flex !important;
          flex-direction: column !important;
          gap: 12px !important;
        }

        .rt-tl-detail-grid {
          display: grid !important;
          grid-template-columns: repeat(5, minmax(110px, 1fr)) !important;
          gap: 12px 16px !important;
        }
        .rt-tl-detail-item {
          display: flex !important;
          flex-direction: column !important;
          gap: 3px !important;
          min-width: 0 !important;
        }
        .rt-tl-detail-label {
          font-size: 10px !important;
          font-weight: 600 !important;
          color: #64748b !important;
          text-transform: uppercase !important;
          letter-spacing: 0.03em !important;
        }
        .rt-tl-detail-value {
          font-size: 12.5px !important;
          font-weight: 500 !important;
          color: #1e293b !important;
          overflow-wrap: anywhere !important;
        }

        .rt-tl-description {
          display: flex !important;
          flex-direction: column !important;
          gap: 3px !important;
          padding-top: 10px !important;
          border-top: 1px solid #f1f5f9 !important;
        }
        .rt-tl-description-label {
          font-size: 10px !important;
          font-weight: 600 !important;
          color: #64748b !important;
          text-transform: uppercase !important;
          letter-spacing: 0.03em !important;
        }
        .rt-tl-description-value {
          font-size: 12.5px !important;
          font-weight: 400 !important;
          color: #334155 !important;
          line-height: 1.4 !important;
        }

        @media (max-width: 1280px) {
          .rt-tl-detail-grid {
            grid-template-columns: repeat(auto-fit, minmax(150px, 1fr)) !important;
          }
        }

        .rt-tl-performer-box {
          display: flex !important;
          align-items: center !important;
          gap: 10px !important;
          padding: 8px 12px !important;
          background: #f8fafc !important;
          border: 1px solid #e2e8f0 !important;
          border-radius: 0 !important;
          flex-wrap: wrap !important;
        }
        .rt-tl-performer-avatar {
          width: 28px !important;
          height: 28px !important;
          border-radius: 0 !important;
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          background: #f5f5f5 !important;
          border: 1px solid #d4d4d4 !important;
          color: #171717 !important;
          font-size: 11px !important;
          font-weight: 600 !important;
          flex-shrink: 0 !important;
        }
        .rt-tl-performer-info {
          display: flex !important;
          align-items: center !important;
          gap: 4px !important;
          flex-wrap: wrap !important;
          min-width: 0 !important;
          flex: 1 1 auto !important;
        }
        .rt-tl-performer-name {
          font-size: 12.5px !important;
          font-weight: 600 !important;
          color: #1e293b !important;
        }
        .rt-tl-performer-email {
          font-size: 12px !important;
          color: #64748b !important;
          font-weight: 400 !important;
        }
        .rt-tl-performer-badge {
          background: #ffffff !important;
          border: 1px solid #cbd5e1 !important;
          padding: 2px 8px !important;
          border-radius: 0 !important;
          font-size: 10.5px !important;
          font-weight: 600 !important;
          color: #475569 !important;
          white-space: nowrap !important;
        }
      `}</style>

      <Modal.Header>
        <div className="rt-header-shell">
          <div className="rt-header-top">
            <div className="rt-header-main">
              <i className="rt-header-icon fa fa-history" aria-hidden="true" />
              <div className="rt-header-copy">
                <h2 className="rt-modal-title">
                  <span className="rt-modal-title-text">
                    <span>Task History</span>
                    {task?.wfPhase && (
                      <span className="rt-modal-title-badge">
                        {task.wfPhase}
                      </span>
                    )}
                  </span>
                </h2>
                <div className="rt-modal-meta-row">
                  {candidateName && (
                    <span className="rt-meta-chip">
                      <i className="fa fa-user" aria-hidden="true" style={{ color: "#9333ea", marginRight: "4px" }} />
                      <span>{candidateName}</span>
                    </span>
                  )}
                  {email && (
                    <span className="rt-meta-chip">
                      <i className="fa fa-envelope" aria-hidden="true" style={{ color: "#0284c7", marginRight: "4px" }} />
                      <span>{email}</span>
                    </span>
                  )}
                  {phone && (
                    <span className="rt-meta-chip">
                      <i className="fa fa-phone" aria-hidden="true" style={{ color: "#16a34a", marginRight: "4px" }} />
                      <span>{phone}</span>
                    </span>
                  )}
                  <span className="rt-meta-chip">
                    <i className="fa fa-tasks" aria-hidden="true" style={{ color: "#2563eb", marginRight: "4px" }} />
                    <span>Process ID: {task?.ciid || "N/A"}</span>
                  </span>
                  <span className="rt-meta-chip">
                    <i className="fa fa-info-circle" aria-hidden="true" style={{ color: "#0891b2", marginRight: "4px" }} />
                    <span>Task: {task?.itemName || "N/A"}</span>
                  </span>
                </div>
              </div>
            </div>
            <button
              type="button"
              className="rt-action-btn"
              onClick={handlehistoryAppModalShowHide}
              title="Close"
            >
              <i className="fa fa-times" aria-hidden="true" />
            </button>
          </div>
        </div>
      </Modal.Header>

      <Modal.Body>
        {!doneTasks || doneTasks.length === 0 ? (
          <div className="wf-table-empty">
            <div className="wf-te-icon-wrap">
              <div className="wf-te-icon">
                <i className="fa fa-history" aria-hidden="true" />
              </div>
            </div>
            <h3 className="wf-te-title">No Task History</h3>
            <p className="wf-te-desc">There are no completed task history logs for this process yet.</p>
          </div>
        ) : (
          <>
            <div className="rt-history-stats-bar">
              <div className="rt-stat-item">
                <span className="rt-stat-label">COMPLETED</span>
                <span className="rt-stat-value">{sortedDoneTasks.length} Tasks</span>
              </div>
              <div className="rt-stat-divider" />
              <div className="rt-stat-item">
                <span className="rt-stat-label">FIRST TASK</span>
                <span className="rt-stat-value">
                  <Moment format="MMM D, YYYY">{sortedDoneTasks[0]?.startDateTime}</Moment>
                </span>
              </div>
              <div className="rt-stat-divider" />
              <div className="rt-stat-item">
                <span className="rt-stat-label">LATEST</span>
                <span className="rt-stat-value">
                  <Moment format="MMM D, YYYY">{sortedDoneTasks[sortedDoneTasks.length - 1]?.endDateTime}</Moment>
                </span>
              </div>
            </div>

            <div className="rt-history-timeline">
              {sortedDoneTasks.map((item, idx) => {
                const avatarText = (item.performerName || "?").split(" ").map(n => n[0]).join("").slice(0, 2).toUpperCase();
                return (
                  <div key={item.wiid} className="rt-history-timeline-item">
                    <div className="rt-history-timeline-badge">
                      {idx + 1}
                    </div>
                    <div className="rt-history-timeline-card">
                      <div className="rt-tl-card-header">
                        <div className="rt-tl-card-title-row">
                          <span className="rt-tl-card-name">{item.itemName}</span>
                          <span className="rt-tl-card-id">#{item.wiid}</span>
                          <span className="rt-tl-order-chip">Order {getDisplayValue(item.orderNumber)}</span>
                          {item.wfPhase && <span className="rt-history-phase-badge">{item.wfPhase}</span>}
                        </div>
                        {item.taskDoneDuration && (
                          <span className="rt-tl-card-duration">
                            {item.taskDoneDuration}
                          </span>
                        )}
                      </div>

                      <div className="rt-tl-card-body">
                        <div className="rt-tl-detail-grid">
                          <div className="rt-tl-detail-item">
                            <span className="rt-tl-detail-label">Item Type</span>
                            <span className="rt-tl-detail-value">{getItemTypeLabel(item.itemType)}</span>
                          </div>
                          <div className="rt-tl-detail-item">
                            <span className="rt-tl-detail-label">Item ID</span>
                            <span className="rt-tl-detail-value">{getDisplayValue(item.itemId)}</span>
                          </div>
                          <div className="rt-tl-detail-item">
                            <span className="rt-tl-detail-label">Task State</span>
                            <span className="rt-tl-detail-value">{getTaskStateLabel(item.taskState)}</span>
                          </div>
                          <div className="rt-tl-detail-item">
                            <span className="rt-tl-detail-label">Started</span>
                            <span className="rt-tl-detail-value">
                              <Moment format="MMM D, YYYY, h:mm a">{item.startDateTime}</Moment>
                            </span>
                          </div>
                          <div className="rt-tl-detail-item">
                            <span className="rt-tl-detail-label">Completed</span>
                            <span className="rt-tl-detail-value">
                              <Moment format="MMM D, YYYY, h:mm a">{item.endDateTime}</Moment>
                            </span>
                          </div>
                        </div>

                        {item.description && (
                          <div className="rt-tl-description">
                            <span className="rt-tl-description-label">Description</span>
                            <span className="rt-tl-description-value">{getDisplayValue(item.description)}</span>
                          </div>
                        )}

                        {shouldShowPerformer(item) && (
                          <div className="rt-tl-performer-box">
                            <span className="rt-tl-performer-avatar">{avatarText}</span>
                            <div className="rt-tl-performer-info">
                              <span className="rt-tl-performer-name">
                                {item.performerName || "System"}
                              </span>
                              {item.performerEmail && (
                                <span className="rt-tl-performer-email">
                                  {item.performerEmail}
                                </span>
                              )}
                            </div>
                            {(item.performerRole || item.performerDepartment || item.performerPartner) && (
                              <span className="rt-tl-performer-badge">
                                {[item.performerRole, item.performerDepartment, item.performerPartner].filter(Boolean).join(" · ")}
                              </span>
                            )}
                          </div>
                        )}

                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </>
        )}
      </Modal.Body>

      <Modal.Footer>
        <button
          type="button"
          className="wf-modal-footer-close-btn"
          onClick={handlehistoryAppModalShowHide}
        >
          <i className="fa fa-times" aria-hidden="true" /> Close
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default TaskHistory;
